import * as lz from 'lz-string';

export const {compressToUint8Array, decompressFromUint8Array} = lz;
